import { styled } from '@ui/components/styled';

export const Container = styled('div', {
  padding: '10px',
});
